// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Lm0U","content":"LayoutSettings_content__3sW5o"};